import {
  Offer,
  RollingOfferProductSequence
} from 'common/contracts';
import { ESaleDiscountDisplayType } from 'constants/enums';
import Decimal from 'decimal.js';
import {
  enrichProgressBarPoints,
  mapSequenceProduct
} from 'views/Offers/utils/offerProductSequence.utils';

export const mapProductsSequence = (
  productsSequence: RollingOfferProductSequence[],
  progressBarOffers: Offer[]
) => {
  return productsSequence.map((item) => ({
    ...item,
    prices: {
      priceInUsdCents: new Decimal(item?.priceInUsdCents || 0)
        .mul(100)
        .toNumber(),
      priceDisplay: `$${item?.priceInUsdCents || 0}`,
      currencyCode: 'USD'
    },
    products: item?.products.map(mapSequenceProduct),
    salePercentage: item?.productSale?.sale || 0,
    salePercentageDisplayType: ESaleDiscountDisplayType.PERCENTAGE,
    badges: item?.badges || [],
    progressBarPoints: enrichProgressBarPoints(
      item?.progressBarPoints,
      progressBarOffers
    )
  }));
};

export type MappedRollingOfferProduct = ReturnType<
  typeof mapProductsSequence
>[number];
